<template>
  <div>
    <div class="container-fluid px-0">
      <Nav
        @show-contrast-view="toggleShowContrast"
        @show-regular-font-view="toggleRegularFontView"
        @show-middle-font-view="toggleMiddleFontView"
        @show-big-font-view="toggleBigFontView"
      />
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 px-0 bg-bee">
          <div id="anim-footer" v-if="showAnimationFooter">
            <lottie-animation
              ref="anim"
              :animationData="require('@/assets/bottom.json')"
              :loop="true"
              :autoPlay="true"
            
            />
          </div>
          <div id="anim-woodpecker" v-if="showAnimationOther">
            <lottie-animation
              ref="anim"
              :animationData="require('@/assets/woodpeckeranim.json')"
              :loop="true"
              :autoPlay="true"              
            />
          </div>
              <div id="wood" v-if="showAnimationOther">
                <img src="../assets/images/lewe_drzewo.png"  alt="Drzewo" />

          </div>
          <Content />
        </div>
        <div class="order-1 order-lg-1 col-lg-5 px-0">
          <Form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "./Content.vue";
import Nav from "./Nav.vue";
import Form from "./Form.vue";
import LottieAnimation from "lottie-web-vue";

export default {
  name: "Page",
  data() {
    return {
      contrastView: false,
      fontRegularView: true,
      fontMiddleView: false,
      fontBigView: false,
      mainPage: true,
      showAnimationFooter: false,
      showAnimationOther: false,
    };
  },
  components: {
    Content,
    Nav,
    Form,
    LottieAnimation,
  },
  methods: {
    toggleShowContrast: function() {
      this.contrastView = !this.contrastView;
    },
    toggleRegularFontView: function() {
      this.fontRegularView = !this.fontRegularView;
    },
    toggleMiddleFontView: function() {
      this.fontMiddleView = !this.fontMiddleView;
    },
    toggleBigFontView: function() {
      this.fontBigView = !this.fontBigView;
    },
    showAnimationFooterFn: function(){
      setTimeout(() => {
        this. showAnimationFooter = true;
      }, 500);
      
    },
       showAnimationOtherFn: function(){
      setTimeout(() => {
        this. showAnimationOther= true;
      }, 700);
      
    }
  },
  created() {
    this.showAnimationFooterFn();
    this.showAnimationOtherFn();
    
  },

  watch: {
    contrastView: function() {
      const el = document.body;
      if (this.contrastView) {
        el.classList.add("body--contrast");
      } else {
        el.classList.remove("body--contrast");
      }
    },
    fontRegularView: function() {
      const el = document.getElementsByTagName("html")[0];
      el.classList.remove("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontMiddleView: function() {
      const el = document.getElementsByTagName("html")[0];

      el.classList.add("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontBigView: function() {
      const el = document.getElementsByTagName("html")[0];

      el.classList.remove("body--middle-font");
      el.classList.add("body--big-font");
    },
  },
};
</script>
